
/*
 * @Author:
 * @Description:
 * @Date: 2024-09-09 14:16:46
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/data/index.js
 */
export const parentStepList = [
  {
    title: '',
    label: 'message.register.validaterBusiness',
    name: 'validateBusiness',
    childrenStepList: [
      {
        title: 'message.register.companyType',
        label: 'message.register.companyType',
        value: 'businessType',
        component: () => import('../components/step-companyType.vue'),
      },
      {
        title: 'message.register.companyDetails',
        label: 'message.register.companyDetails',
        value: 'businessDetails',
        component: () => import('../components/step-companyDetails.vue'),
      },
      {
        title: 'message.register.companyRepresentative',
        label: 'message.register.companyRepresentative',
        value: 'businessRepresentative',
        component: () => import('../components/step-companyRepresentative.vue'),
      },
      {
        title: 'message.register.companyOwner',
        label: 'message.register.companyOwner',
        value: 'businessOwners',
        component: () => import('../components/step-companyOwner.vue'),
      },
      {
        title: 'message.register.websiteOrApplication',
        label: 'message.register.websiteOrApplication',
        value: 'websiteOrAppDetails',
        component: () => import('../components/step-websiteOrApplication.vue'),
      },
      // {
      //   title: 'message.register.bankAccount',
      //   label: 'message.register.bankAccount',
      //   value: 'bankAccount',
      //   component: () => import('../components/step-bankAccount.vue'),
      // },
      // {
      //   title: 'message.register.status',
      //   label: 'message.register.status',
      //   value: 'status',
      //   component: () => import('../components/step-status.vue'),
      // },
    ],
  },
  {
    title: '',
    label: 'message.register.bankAccount',
    name: 'addBankAccount',
    value: 'bankAccount',
    component: () => import('../components/step-bankAccount.vue'),
  },
  {
    title: '',
    label: 'message.register.status',
    value: 'status',
    childrenStepList: [
      {
        title: 'message.register.status',
        label: 'message.register.summary',
        value: 'status',
        component: () => import('../components/step-status.vue'),
      },
    ],
  },
];
export const stepList = [
  {
    title: 'message.register.companyType',
    label: 'message.register.companyType',
    value: 'businessType',
    component: () => import('../components/step-companyType.vue'),
  },
  {
    title: 'message.register.companyDetails',
    label: 'message.register.companyDetails',
    value: 'businessDetails',
    component: () => import('../components/step-companyDetails.vue'),
  },
  {
    title: 'message.register.companyRepresentative',
    label: 'message.register.companyRepresentative',
    value: 'businessRepresentative',
    component: () => import('../components/step-companyRepresentative.vue'),
  },
  {
    title: 'message.register.companyOwner',
    label: 'message.register.companyOwner',
    value: 'businessOwners',
    component: () => import('../components/step-companyOwner.vue'),
  },
  {
    title: 'message.register.websiteOrApplication',
    label: 'message.register.websiteOrApplication',
    value: 'websiteOrAppDetails',
    component: () => import('../components/step-websiteOrApplication.vue'),
  },
  {
    title: 'message.register.bankAccount',
    label: 'message.register.bankAccount',
    value: 'bankAccount',
    component: () => import('../components/step-bankAccount.vue'),
  },
  {
    title: 'message.register.status',
    label: 'message.register.status',
    value: 'status',
    component: () => import('../components/step-status.vue'),
  },
];
